import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store/store';
import { Provider } from 'react-redux';
import {Toaster} from 'react-hot-toast'
import { UserProvider } from '../src/contexts/UserContext';

import { ThemeProvider, CssBaseline } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { getDesignTokens } from './theme'; 

const Root = () => {
  const [mode, setMode] = useState('light');
  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <Provider store={store}>
      <UserProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App toggleTheme={() => setMode(prev => (prev === 'light' ? 'dark' : 'light'))} mode={mode} />
          <Toaster />
        </ThemeProvider>
      </UserProvider>
    </Provider>
  );
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

reportWebVitals();
